import styled from "@emotion/styled";

const ArrowRight = styled.svg<{ pointer?: boolean }>`
  cursor: ${({ pointer }) => (pointer ? "pointer" : "default")};
`;

export const Styled = {
  ArrowRight,
};
